export const DEFAULT_DOCUMENT_POLICY = { maximum_size_bytes: 15 * 1024 * 1024, maximum_size_human: '15 MB', disclosure: 'Accepted format: PDF. Maximum size: 15 MB per document.', security_review_enforced: false };
export function validateDocumentSelection(file, policy = DEFAULT_DOCUMENT_POLICY) {
  if (!file) return '';
  if (file.size > policy.maximum_size_bytes) return `The document exceeds the ${policy.maximum_size_human} per-document limit.`;
  if ((file.type && !['application/pdf', 'application/x-pdf'].includes(file.type)) || !file.name.toLowerCase().endsWith('.pdf')) return 'Only PDF documents are supported.';
  return '';
}
